import { saikaClient } from 'saika-client';
import { getCookie } from '../commons/cookie';

const saikaData = (bodyData = {}) => ({
  source: 'simple-login',
  body: {
    b2wSid: getCookie('b2wSid') || null,
    b2wPid: getCookie('b2wPid') || null,
    b2wUid: getCookie('b2wUid') || null,
    ...bodyData
  }
});

const signUpPageLoadData = () => ({
  ...saikaData(),
  eventName: 'simple-login-cadastro-page-load'
});

const successfulSignUpData = () => ({
  ...saikaData(),
  eventName: 'simple-login-cadastro-sucesso'
});

export const dispatchSignUpPageLoadSaikaEvent = () => saikaClient(signUpPageLoadData());
export const dispatchSuccessfulSignUpSaikaEvent = () => saikaClient(successfulSignUpData());

const loginData = eventObj => ({
  ...saikaData(eventObj),
  eventName: 'simple-login-entrar-sucesso'
});

export const dispatchLoginSaikaEvent = eventObj => saikaClient(loginData(eventObj));
